// extracted by mini-css-extract-plugin
module.exports = {"root":"language-switcher_root__CeCHp","label":"language-switcher_label__yV3u2","menu__item":"language-switcher_menu__item__DIT8n"};